( function () {

    const preview = $('.widget-preview');
    const purposes = $('.preview-purposes');
    const purposesRoute = preview.attr('data-purposes-route');

    if ( preview.length ) {

        // Setting width on height on change
        $('.widget__size').on('keyup input', function () {
            let _this = $(this);
            let property = _this.attr('data-property');
            preview.css(property, _this.val());
        });

        $('.widget__color').on('change', function () {
            let _this = $(this);
            let property = _this.attr('data-property');
            let selector = _this.attr('data-selector');
            $(selector).css(property, _this.val());
        });

        $('.widget__country').on('change', function () {
            let _this = $(this);
            let selector = _this.attr('data-selector');

            $(selector).val(_this.val()).attr('selected', true);

            let chosenPassport = $('.preview-passports').val();
            let chosenDestination = $('.preview-destinations').val();

            populatePurposesOptions(chosenPassport, chosenDestination);
        });
    }

    // Fetch and populate purposes select element.
    function populatePurposesOptions(chosenPassport, chosenDestination) {
        if ( chosenPassport !== 0 && chosenDestination !== 0 ) {
            $.ajax({
                method: 'GET',
                url: purposesRoute,
                data: {
                    passport: chosenPassport,
                    destination: chosenDestination
                }
            }).done(function (items) {
                purposes.html('<option value="0">Selecteer</option>');
                items.data.forEach(function (item) {
                    purposes.append('<option value="' + item.id + '">' + item.name + '</option>');
                });
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            });
        }
        else {
            purposes.html('<option value="0">Selecteer</option>');
        }
    }

    $('.btn-generate-widget').click(function () {
        let widgetJS = $(this).attr('data-widget-js');
        let widgetCSS = $(this).attr('data-widget-css');
        let passportsRoute = $(this).attr('data-passports-route');
        let destinationsRoute = $(this).attr('data-destinations-route');
        let modalSelector = $(this).attr('data-target');
        let width = preview.outerWidth();
        let height = preview.outerHeight();
        let titleColor = $('#colorMain').val();
        let labelColor = $('#colorSub').val();
        let bgColor = $('#colorBg').val();
        let btnColor = $('#colorBtn').val();
        let passport = $('#passports').val();
        let destination = $('#destinations').val();

        let code = "<div id='visaWidgetWrapper'></div><script>(function (w,d,s,o,f,js,fjs) {w['visaWidget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);}(window, document, 'script', 'vw', '" + widgetJS + "'));vw('init',{w:" + width + ",h:" + height + ",tc:'" + titleColor + "',lc:'" + labelColor + "',bgc:'" + bgColor + "',btc:'" + btnColor + "',p:" + passport + ",d:" + destination + ",pr:'"+purposesRoute+"',css:'"+widgetCSS+"',par:'"+passportsRoute+"',dr:'"+destinationsRoute+"'});</script>";

        $(modalSelector).find('textarea').text(code);
    });

} )();

